import Slider from "react-slick";
import React from "react";
import styles from "./style.module.css";
import sectionStyles from "../../sections/sectionStyles.module.css";

export const Carousel = ({
  carouselData,
  carouselData: { underlinedHeader, header, subHeader, description, slides },
}) => {
  return (
    <>
      <h3 className={sectionStyles.headerText}>
        {underlinedHeader && (
          <span className={styles.underlined}>{underlinedHeader}</span>
        )}
        {header}
      </h3>
      <div className={styles.wrapContainer}>
        <div className={styles.sliderContainer}>
          <Slider dots={true} infinite={true} speed={1000} draggable={true}>
            {slides.map((imgSrc, index) => (
              <img
                key={`slide_${index}`}
                className={styles.sliderImage}
                src={imgSrc}
                alt={`slide ${index}`}
              />
            ))}
          </Slider>
        </div>
        <div className={styles.textContainer}>
          {!!subHeader && <h4 className={styles.subHeader}>{subHeader}</h4>}
          {!!description && <p className={styles.description}>{description}</p>}
        </div>
      </div>
    </>
  );
};
